"use strict";

var _slicedToArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Body = void 0;

var _react = require("react");

var Matter = _interopRequireWildcard(require("matter-js"));

require("./set-poly-decomp");

var _Sprite = require("../Sprite");

var _Ticker = require("../Ticker");

var _View = require("../UI/View");

var _Composite = require("./Composite");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // `Matter.Bodies.fromVertices` dependence `poly-decomp` to decomposed concave vertices.


var eventNames = ['sleepStart', 'sleepEnd'];

var BodyComponent = function BodyComponent(_ref, ref) {
  var useBody = _ref.useBody,
      _ref$events = _ref.events,
      events = _ref$events === void 0 ? {} : _ref$events,
      isSleeping = _ref.isSleeping,
      isStatic = _ref.isStatic,
      isSensor = _ref.isSensor;
  var body = useBody();
  var composite = (0, _Composite.useComposite)();
  (0, _react.useEffect)(function () {
    Matter.Composite.add(composite, body);
    (0, _View.setRef)(ref, body);
    return function () {
      Matter.Composite.remove(composite, body);
    };
  }, []);
  if (isSleeping != null && isSleeping != body.isSleeping) Matter.Sleeping.set(body, isSleeping);
  if (isStatic != null && isStatic != body.isStatic) Matter.Body.setStatic(body, isStatic);
  if (isSensor != null && isSensor != body.isSensor) body.isSensor = isSensor;
  eventNames.forEach(function (name) {
    return (0, _react.useEffect)(function () {
      var callback = events[name];
      if (callback == null) return;
      Matter.Events.on(body, name, callback);
      return function () {
        return Matter.Events.off(body, name, callback);
      };
    }, [events[name]]);
  });
  return null;
};

BodyComponent.displayName = 'Body';

var SpriteBody = function SpriteBody(newBody) {
  return {
    useBody: function useBody() {
      var sprite = (0, _Sprite.useSprite)();
      var body = (0, _react.useMemo)(function () {
        if (sprite == null) throw new Error('`Sprite` context not found for create `Physics.Body`');
        return newBody(sprite);
      }, [sprite]);
      var ticker = (0, _Ticker.useTicker)();
      (0, _react.useEffect)(function () {
        if (body.isStatic) return;
        Matter.Body.setVelocity(body, body.velocity);
        var sub = ticker.each(function (_delta) {
          // if (body.id === 100) console.log(body.velocity);
          sprite.rotation = body.angle;
          sprite.position.x = body.position.x;
          sprite.position.y = body.position.y;
        });
        return function () {
          return sub.unsubscribe();
        };
      }, [body.isStatic]);
      return body;
    }
  };
}; // eslint-disable-next-line @typescript-eslint/no-empty-interface


var SpriteCircle = function SpriteCircle(options) {
  return SpriteBody(function (_ref2) {
    var x = _ref2.x,
        y = _ref2.y,
        width = _ref2.width;
    return Matter.Bodies.circle(x, y, width / 2, options);
  });
};

var SpriteRectangle = function SpriteRectangle(options) {
  return SpriteBody(function (_ref3) {
    var x = _ref3.x,
        y = _ref3.y,
        width = _ref3.width,
        height = _ref3.height;
    return Matter.Bodies.rectangle(x, y, width, height, options);
  });
};

var SpritePath = function SpritePath(points, options) {
  var newBody = function newBody(sprite) {
    var vertices = [points(sprite).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          x = _ref5[0],
          y = _ref5[1];

      return Matter.Vector.create(x, y);
    })];
    return Matter.Bodies.fromVertices(sprite.x, sprite.y, vertices, options);
  };

  return SpriteBody(newBody);
};

var SpriteTriangle = function SpriteTriangle(options) {
  return SpritePath(function (_ref6) {
    var width = _ref6.width,
        height = _ref6.height;
    return [[width / 2, 0], [0, height], [width, height]];
  }, options);
};

var Body = (0, _react.forwardRef)(BodyComponent);
exports.Body = Body;
Body.Sprite = SpriteBody;
Body.SpriteCircle = SpriteCircle;
Body.SpriteRectangle = SpriteRectangle;
Body.SpritePath = SpritePath;
Body.SpriteTriangle = SpriteTriangle;
Body.nextCategory = Matter.Body.nextCategory;
Body.nextGroup = Matter.Body.nextGroup;